import React, { useState, useEffect } from 'react';
import { getAuth } from 'firebase/auth';
import { getFirestore, doc, getDoc } from 'firebase/firestore';
import './NotificationBar.css';

function NotificationBar() {
  const [isVisible, setIsVisible] = useState(false);
  const auth = getAuth();
  const db = getFirestore();
  const user = auth.currentUser;

  useEffect(() => {
    const fetchUserPlan = async () => {
      if (user) {
        const userDoc = await getDoc(doc(db, 'users', user.uid));
        if (userDoc.exists() && userDoc.data().plano === 'Gratuito') {
          setIsVisible(true); // Exibe a notificação se o plano for "Gratuito"
        }
      }
    };

    fetchUserPlan();
  }, [user, db]);

  if (!isVisible) {
    return null;
  }

  const handleClose = () => {
    setIsVisible(false);
  };

  return (
    <div className="notification-bar">
      <p className="notification-text">
        Você está usando o plano <strong>Gratuito</strong>.
        <a href="/plano-premium" className="notification-link">
          Assine o plano Premium
        </a>{' '}
        e tenha acesso a mais recursos!
      </p>
      <div
        className="close-button-notification-bar"
        onClick={handleClose}
        aria-label="Fechar notificação"
      >
        &times;
      </div>
    </div>
  );
}

export default NotificationBar;
